import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { DropdownDivider, DropdownItem, DropdownMenu, Icon } from "semantic-ui-react";

import { Dropdown, useCan } from "components";
import "components/NavBar/components/AccountDropdown/AccountDropdown.scss";
import { usePermanentRealTimeUser } from "hooks";
import { useLogout } from "modules/Login/hooks";
import { toggleZohoDeskASAP } from "plugins/ZohoDeskASAP";
import { PATHS } from "router/paths";

const openReactQueries = () => {
  const reactQueryButton = document.querySelector<HTMLElement>(".tsqd-open-btn");
  if (!reactQueryButton) return;

  reactQueryButton.click();
};

export const AccountDropdown = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const logout = useLogout();
  const { user } = usePermanentRealTimeUser();
  const canBrowseAccountsPage = useCan("browse", "account-page");

  const profilePicture = user?.profile_picture;
  const profileName = `${user?.first_name || ""} ${user?.last_name || ""}`.trim();

  return (
    <div className="AccountDropdown">
      <div className="account-dropdown">
        <Dropdown
          icon={null}
          trigger={
            profilePicture ? (
              <img alt={profileName} title={profileName} className="small-profile-icon profile-avatar" src={profilePicture} />
            ) : (
              <Icon title={profileName} className="circle user no-profile-picture-icon" />
            )
          }
        >
          <DropdownMenu className="account-dropdown-container" direction="left">
            <DropdownItem className="profile-details">
              {profilePicture ? (
                <img title={profileName} className="profile-avatar" src={profilePicture} />
              ) : (
                <Icon title={profileName} size="huge" className="circle user" />
              )}
              <h1 className="mt-15">{profileName}</h1>
            </DropdownItem>
            <DropdownDivider />

            {canBrowseAccountsPage && (
              <>
                <DropdownItem text={t("v8_account_settings", "Account Settings")} value="account_settings" onClick={() => history.push(PATHS.ACCOUNT)} />
                <DropdownDivider />
              </>
            )}
            <DropdownItem text={t("v8_tickets_help_center", "Tickets & Help Center")} value="tickets_help_center" onClick={toggleZohoDeskASAP} />
            <DropdownDivider />
            {process.env.NODE_ENV !== "production" && (
              <>
                <DropdownItem text="React Queries" value="react_queries" onClick={openReactQueries} />
                <DropdownDivider />
              </>
            )}
            <DropdownItem text={t("v8_logout", "Log out")} value="Logout" onClick={logout} />
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
  );
};
